export const environment = {
  production: true,
  apiHost: window.location.host + '/api',
  version: 'build 98a38cd7',
};
